function SupportItem({ title, description }) {
  return (
    <div className="support-item">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
}

export default SupportItem;
